import { observer } from "mobx-react-lite"
import type { JSX } from "react"
import React from "react"

import "./dashboard-tile-view.css"
import { randomBetween } from "../../utils/random-between"
import { useAnimateValueEffect } from "../../utils/use-animate-value-effect"

export enum DashboardTileType {
    insecure = "insecure",
    outdated = "outdated",
    active = "active"
}

interface Props {
    title: string
    count: number
    type: DashboardTileType
}

export const DashboardTileView = observer(({ title, count, type }: Props): JSX.Element => {
    const ref = React.useRef<HTMLSpanElement>(null)
    useAnimateValueEffect(ref, randomDuration(), count, "\u2014")

    return (
        <div key={title} className={`dashboard-tile-view ${type}`}>
            <div className="head">{title}</div>
            <div className="count">
                <span ref={ref}></span>
            </div>
        </div>
    )
})

function randomDuration() {
    return randomBetween(1_000, 1_600)
}
